import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';

import { MessageModel } from '../types';

import { MessageFooterMode } from './types';

@Component({
  selector: 'message-footer',
  templateUrl: './message-footer.component.html',
  styleUrls: ['./message-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class MessageFooterComponent {
  @Input() message!: MessageModel;
  @Input() mode: MessageFooterMode = 'reply';
  /** Скрыть с очисткой черновика или без */
  @Output() close = new EventEmitter<boolean>();

  deleteFooterMessage() {
    if (this.mode === 'edit') {
      this.close.emit(true);
    } else {
      this.close.emit(false);
    }
  }
}
